export function getRequestStatusTone(status) {
  const normalizedStatus = String(status || '').toLowerCase();

  if (normalizedStatus === 'approved') {
    return 'approved';
  }

  if (normalizedStatus === 'denied') {
    return 'denied';
  }

  if (normalizedStatus.includes('blocked')) {
    return 'warning';
  }

  if (normalizedStatus === 'review needed') {
    return 'review';
  }

  return 'pending';
}

export function buildRequestQueueSummary(requests) {
  return {
    all: requests.length,
    approved: requests.filter(request => String(request.status || '').toLowerCase() === 'approved').length,
    denied: requests.filter(request => String(request.status || '').toLowerCase() === 'denied').length,
    pending: requests.filter(request => String(request.status || '').toLowerCase() === 'pending').length,
    reviewNeeded: requests.filter(request => String(request.status || '').toLowerCase() === 'review needed').length
  };
}

export function filterRequestsByQueue(requests, queue) {
  const normalizedQueue = String(queue || 'pending').toLowerCase();

  switch (normalizedQueue) {
    case 'all':
      return requests;
    case 'review needed':
      return requests.filter(request => String(request.status || '').toLowerCase() === 'review needed');
    case 'approved':
      return requests.filter(request => String(request.status || '').toLowerCase() === 'approved');
    case 'denied':
      return requests.filter(request => String(request.status || '').toLowerCase() === 'denied');
    case 'pending':
    default:
      return requests.filter(request => String(request.status || '').toLowerCase() === 'pending');
  }
}

export function canReviewRequest(request) {
  return ['pending', 'review needed'].includes(String(request?.status || '').toLowerCase());
}

export function isAttendanceEvent(request) {
  const eventType = String(request?.eventType || '').toLowerCase();
  return ['sick_call', 'other_absence', 'late_arrival'].includes(eventType);
}

export function isVacationEvent(request) {
  return String(request?.eventType || '').toLowerCase().startsWith('vacation');
}
